import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthProvider";
import LoadingScreen from "../components/LoadingScreen/LoadingScreen";

export default function PublicRoute() {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return <LoadingScreen />;
  }

  // Se já está logado, não pode acessar login/register
  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
}
